export enum VotingTypes {
  Fibonnacci = 1,
  Random = 2
}